import { Axios } from "./axios";
import { HCCCD_API, FILE_BASE64, HOST_API, MEDIA_CONVERT_PDF, MEDIA_CONVERT_IMAGE } from "../api";

function uploadFileBase64(data) {
  return Axios("post", `${HCCCD_API}${FILE_BASE64}${"/upload"}`, data);
}

function downloadFileBase64(id) {
  return Axios("get", `${HCCCD_API}${FILE_BASE64}${"/download/"}${id}`);
}

function convertBase64ToPdf(base64Data) {
  return Axios("post", `${HOST_API}${MEDIA_CONVERT_PDF}`, { base64Data });
}

function convertBase64ToImage(base64Data) {
  return Axios("post", `${HOST_API}${MEDIA_CONVERT_IMAGE}`, { base64Data });
}

export { uploadFileBase64, downloadFileBase64, convertBase64ToPdf, convertBase64ToImage };
